import React from 'react';
import { Text } from '@rneui/themed';
import { View } from '../../components/elements';
import { PurchaseableCard } from './PurchaseableCard';
export const PurchaseableList = ({ purchaseables, title = '', }) => {
    if (purchaseables.length === 0) {
        return;
    }
    return (React.createElement(View, { style: { marginBottom: 20 } },
        title && purchaseables.length > 0 && (React.createElement(Text, { h2: true, style: { textAlign: 'center' } }, title)),
        purchaseables.map((purchaseable) => (React.createElement(PurchaseableCard, { key: purchaseable.id, purchaseable: purchaseable })))));
};
//# sourceMappingURL=PurchaseableList.js.map